// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a8cbfcc6","455":"55956179"}[chunkId] + ".chunk.js";
};